import { Component } from '@angular/core';
import { RouterLinkWithHref } from '@angular/router';
import { AsyncPipe } from '@angular/common';

import { mainNavigation } from '@Constants';

import { AuthService } from '@Services';

@Component({
  selector: 'app-header',
  imports: [RouterLinkWithHref, AsyncPipe],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
})
export class HeaderComponent {
  mainNavigation = mainNavigation;

  constructor(private _authService: AuthService) {}

  isLogged() {
    return this._authService.isLoggedIn();
  }
}
